import type { InternalRequest } from '../client.js';

export interface RiskIncidentFeature {
  type: 'Feature';
  id: string;
  geometry: { type: 'Point'; coordinates: [number, number] }; // [lng, lat]
  properties: {
    id: string;
    title: string;
    severity: string;
    category_name: string | null;
    incident_date?: string | null;
    is_verified?: boolean;
  };
}

export interface RiskIncidentCollection {
  type: 'FeatureCollection';
  features: RiskIncidentFeature[];
}

export function riskmizeEndpoints(req: InternalRequest) {
  return {
    /** GET /riskmize/incidents — GeoJSON FeatureCollection (module-gated server-side). */
    incidents: () => req.request<RiskIncidentCollection>('/riskmize/incidents'),
  };
}
